(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('[data-faq-nav]');
    if (!nav) return;

    const navList = nav.querySelector('.faq__nav-list');
    const categories = document.querySelectorAll('.faq__category');

    if (categories.length === 0) return;

    // Build nav links from rendered category headings
    categories.forEach(cat => {
      const heading = cat.querySelector('.faq__category-heading');
      if (!heading) return;

      const li = document.createElement('li');
      li.className = 'faq__nav-item';

      const a = document.createElement('a');
      a.href = '#' + cat.id;
      a.className = 'faq__nav-link';
      a.setAttribute('data-faq-nav-link', '');
      a.textContent = heading.textContent.trim();

      li.appendChild(a);
      navList.appendChild(li);
    });

    const navLinks = nav.querySelectorAll('[data-faq-nav-link]');

    // Smooth scroll on nav click
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);
        if (target) {
          const offset = 100;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }

        navLinks.forEach(l => l.classList.remove('faq__nav-link--active'));
        link.classList.add('faq__nav-link--active');
      });
    });

    // Intersection observer for active state
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          navLinks.forEach(l => l.classList.remove('faq__nav-link--active'));
          const activeLink = nav.querySelector(`[data-faq-nav-link][href="#${id}"]`);
          if (activeLink) activeLink.classList.add('faq__nav-link--active');
        }
      });
    }, { rootMargin: '-100px 0px -60% 0px' });

    categories.forEach(cat => observer.observe(cat));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('[data-policy-nav]');
    if (!nav) return;

    const navList = nav.querySelector('.policy__nav-list');
    const sections = document.querySelectorAll('.policy__section');

    if (sections.length === 0) return;

    sections.forEach(sec => {
      const heading = sec.querySelector('.policy__section-heading');
      if (!heading) return;

      const li = document.createElement('li');
      li.className = 'policy__nav-item';

      const a = document.createElement('a');
      a.href = '#' + sec.id;
      a.className = 'policy__nav-link';
      a.setAttribute('data-policy-nav-link', '');
      a.textContent = heading.textContent.trim();

      li.appendChild(a);
      navList.appendChild(li);
    });

    const navLinks = nav.querySelectorAll('[data-policy-nav-link]');

    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);
        if (target) {
          const offset = 100;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }

        navLinks.forEach(l => l.classList.remove('policy__nav-link--active'));
        link.classList.add('policy__nav-link--active');
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          navLinks.forEach(l => l.classList.remove('policy__nav-link--active'));
          const activeLink = nav.querySelector(`[data-policy-nav-link][href="#${id}"]`);
          if (activeLink) activeLink.classList.add('policy__nav-link--active');
        }
      });
    }, { rootMargin: '-100px 0px -60% 0px' });

    sections.forEach(sec => observer.observe(sec));
  });

  } catch(e) { console.error(e); }
})();
})();
